<template>
  <div
    v-if="sessionStore.isLoggedIn"
    class="flex-column align-items-start selfcare-side-bar padding24 grow"
  >
    <div class="flex-column stretch grow">
      <div class="logo">
        <img
          v-if="logoBigUrl"
          :src="logoBigUrl"
          alt="logo"
        >
      </div>
      <div class="menu">
        <SelfcareMenu />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useBrandingStore } from "~~/stores/branding";
import {useSessionStore} from "~/stores/session";

const brandingStore = useBrandingStore();

const sessionStore = useSessionStore();

const logoBigUrl = computed(() => brandingStore.logoBigUrl);
</script>

<style scoped lang="scss">
.logo {
  display: block;
  img {
    max-width: 176px;
    max-height: 44px;
  }
}

.menu {
  margin-top: 32px;
  display: flex;
  flex: 1;
  flex-direction: column;
}
</style>
